// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

const { jwt } = useJwt({loginEndpoint: `${process.env.REACT_APP_API_URL}/api/v1/login`,
registerEndpoint: `${process.env.REACT_APP_API_URL}/api/v1/register`,
refreshEndpoint: `${process.env.REACT_APP_API_URL}/api/v1/refresh-token`,
logoutEndpoint: `${process.env.REACT_APP_API_URL}/api/v1/logout`})

export default jwt
